import { ILoyaltyUrlRequest } from 'core/model/interfaces/banners.interface';
import { customizationData } from './customization.data';

export const customizationService = {
  getBanners: (customerId: number) => customizationData.getBanners(customerId),
  getLoyaltyUrl: (request: ILoyaltyUrlRequest) => customizationData.getLoyaltyUrl(request),
  getShortcuts: (customerId: number) => customizationData.getShortcuts(customerId),
};
